import Loader from '../../Components/Common/Loader'
import { useState } from 'react'
import auth from '../../api/auth/hooks'
import { withRouter, Redirect } from 'react-router-dom'
import Header from '../Header'
import SideMenu from './SideMenu/SideMenu'
import style from './AdminLayout.module.css'

const AdminLayout = ({ children }) => {
    const [showMenu, setShowMenu] = useState(false)

    const { data: roles, isPending } = auth.CurrentAgent.useQuery({ select: (data) => data.roles })

    const toggleMenu = () => {
        setShowMenu(!showMenu)
    }

    if (isPending) {
        return (
            <div id="layout-wrapper">
                <div className="full-page-loader">
                    <Loader />
                </div>
            </div>
        )
    }

    if (!roles?.includes('ROLE_ADMIN')) return <Redirect to="/" />

    return (
        <>
            <div id="layout-wrapper">
                <Header btnFunction={toggleMenu} />
                <div className={style.mainContent}>
                    <div className={style.pageContentAdmin}>
                        <SideMenu className={style.sideMenu} showMenu={showMenu} setShowMenu={setShowMenu} />
                        <div className={style.pageContentChildren}>{children}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withRouter(AdminLayout)
